export const TrafficType = Object.freeze({
    LOGGED_OUT: 'logged_out',
    USER: 'user',
});

export const FeatureFlag = Object.freeze({
    BOYSENBERRY_ADDRESS_AUTOCOMPLETE_DELIVERY: 'boysenberry-address-autocomplete-delivery',
    BOYSENBERRY_ADDRESS_AUTOCOMPLETE_PROFILE: 'boysenberry-address-autocomplete-profile',
    DRIVER_TIPS_OPTIONAL_COPY: 'driver-tips-optional-copy',
    MEMBERSHIP: 'membership',
    MEMBERSHIP_SIGNUP: 'membership-signup',
    MOBILE_PAYMENT_CTA: 'mobile-payment-cta',
    OPERATIONS_FEE: 'operations-fee',
    REORDER_EXPERIENCE_BUY_IT_AGAIN: 'reorder-experience-buy-it-again',
    UP_SELLS_CAROUSEL_PLP: 'upsells-carousel-plp',
    UP_SELLS_CAROUSEL_PDP: 'upsells-carousel-pdp',
    STICKY_SUMMARY_CTA: 'sticky-summary-cta',
});

export const LOGGED_OUT_FEATURE_FLAGS = [
    FeatureFlag.MEMBERSHIP_SIGNUP,
    FeatureFlag.MOBILE_PAYMENT_CTA,
    FeatureFlag.STICKY_SUMMARY_CTA,
    FeatureFlag.OPERATIONS_FEE,
];

export const USER_FEATURE_FLAGS = [
    FeatureFlag.BOYSENBERRY_ADDRESS_AUTOCOMPLETE_DELIVERY,
    FeatureFlag.BOYSENBERRY_ADDRESS_AUTOCOMPLETE_PROFILE,
    FeatureFlag.DRIVER_TIPS_OPTIONAL_COPY,
    FeatureFlag.OPERATIONS_FEE,
    FeatureFlag.REORDER_EXPERIENCE_BUY_IT_AGAIN,
    FeatureFlag.UP_SELLS_CAROUSEL_PLP,
    FeatureFlag.UP_SELLS_CAROUSEL_PDP,
];
